import { useState } from "react";
import { CalendarDays } from "lucide-react";

type Props = {
  minDays: number;
  maxDays: number;
  onRangeChange: (minDays: number, maxDays: number) => void;
};

const MoveInDateRangeSelector = ({ minDays, maxDays, onRangeChange }: Props): JSX.Element => {
  const [localMinDays, setLocalMinDays] = useState<string>(minDays.toString());
  const [localMaxDays, setLocalMaxDays] = useState<string>(maxDays.toString());

  const handleMinDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalMinDays(value);

    const numValue = parseInt(value) || 0;
    const maxValue = parseInt(localMaxDays) || 0;

    if (numValue <= maxValue) {
      onRangeChange(numValue, maxValue);
    } else {
      // If min is greater than max, adjust max to be equal to min
      setLocalMaxDays(value);
      onRangeChange(numValue, numValue);
    }
  };

  const handleMaxDaysChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalMaxDays(value);

    const numValue = parseInt(value) || 0;
    const minValue = parseInt(localMinDays) || 0;

    if (numValue >= minValue) {
      onRangeChange(minValue, numValue);
    } else {
      // If max is less than min, adjust min to be equal to max
      setLocalMinDays(value);
      onRangeChange(numValue, numValue);
    }
  };

  const handleMinDaysBlur = () => {
    const numValue = parseInt(localMinDays) || 0;
    const adjustedValue = Math.max(0, numValue);
    setLocalMinDays(adjustedValue.toString());
    onRangeChange(adjustedValue, parseInt(localMaxDays) || 0);
  };

  const handleMaxDaysBlur = () => {
    const numValue = parseInt(localMaxDays) || 0;
    const adjustedValue = Math.max(0, numValue);
    setLocalMaxDays(adjustedValue.toString());
    onRangeChange(parseInt(localMinDays) || 0, adjustedValue);
  };

  return (
    <div>
      <div className="mb-1 flex items-center gap-1">
        <CalendarDays className="size-3 text-[#9F9DB0]" />
        <span className="text-xs text-[#9F9DB0]">
          Rango días mudanza
        </span>
      </div>
      <div className="flex items-center gap-2">
        <div>
          <input
            type="number"
            className="w-20 rounded-md border border-[#DFDEE2] bg-white px-2 py-1.5 text-center text-sm focus:border-[#4012AB] focus:outline-none focus:ring-1 focus:ring-[#4012AB] hover:border-[#9F9DB0]"
            value={localMinDays}
            onChange={handleMinDaysChange}
            onBlur={handleMinDaysBlur}
            min="0"
            placeholder="0"
          />
        </div>
        <span className="text-sm font-medium text-[#9F9DB0]">-</span>
        <div>
          <input
            type="number"
            className="w-20 rounded-md border border-[#DFDEE2] bg-white px-2 py-1.5 text-center text-sm focus:border-[#4012AB] focus:outline-none focus:ring-1 focus:ring-[#4012AB] hover:border-[#9F9DB0]"
            value={localMaxDays}
            onChange={handleMaxDaysChange}
            onBlur={handleMaxDaysBlur}
            min="0"
            placeholder="45"
          />
        </div>
        <span className="ml-1 text-xs text-[#9F9DB0]">días</span>
      </div>
    </div>
  );
};

export default MoveInDateRangeSelector;
